// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "0dc6e0dc0edb6e5ed3bf" + ".js";
};